import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;

export const ModalContainer = styled.div`
  display: flex;
  max-width: 460px;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  gap: 24px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  font-family: Figtree;
  letter-spacing: -0.3px;
`;

export const Label = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const Input = styled.input`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
  color: white;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`;

export const ListItem = styled.li`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.42px;
  opacity: 0.67;
`;

export const ListItem2 = styled.li`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.42px;
`;

export const LightText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: -0.42px;
  opacity: 0.4;
`;

export const BoldText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -0.42px;
`;
export const TextRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const TronContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
`;

export const TronRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const TronIcon = styled.img``;

export const Address = styled.div`
  border-radius: 4px;
  border: 0.5px solid #325682;
  background: #142743;

  display: flex;
  width: 44px;
  height: 22px;
  padding: 12px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;

  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.42px;
`;
